export const config = {
  territoryUrl: process.env.REACT_APP_TERRITORY_URL,
  territoryOldUrl: process.env.REACT_APP_TERRITORY_OLD_URL,
};
